import { baseURL } from '../../config/constant';
import Utils from '../utils';
const getdashboard = async (id) => {
  try {
    const apiOptions = {
      endpoint: `${baseURL}/api/dashboard?company_id=${id}`,
      headers: {
        Authorization: `Bearer ${Utils.getCurrentToken()}`,
      },
      method: 'GET',
    };
    const apiResponse = await Utils.CallApi(apiOptions);
    return apiResponse.data;
  } catch (error) {
    return error;
  }
};
const DashBoardActions = {
  getdashboard,
};

export default DashBoardActions;
